import React,{useRef} from 'react'
import {motion} from 'framer-motion'

const modalVariant={
	hidden:{
		y:"-40vh",
		opacity:0
	},
	visible:{
		opacity:1,
		y:"20vh",
		transition:{
			// duration:0.2,
			type:"spring",
			mass:0.4
		}
	}
}
const overlayVariant={
	visible:{
		transition:{
			when:"beforeChildren"
		}
	}
}
export default function Modal({showModal,setShowModal,children}) {
	if(!showModal) return null
	return (
		<motion.div className="overlay-modal"
			exit={{opacity:0}}
			variants={overlayVariant}
			animate="visible"
		>
			<motion.div className="content" variants={modalVariant} animate="visible" initial="hidden">
				<span className="overlay-close" onClick={()=>setShowModal(false)}>close</span>
				{children}
			</motion.div>
		</motion.div>
	)
}